module.exports = __webpack_public_path__ + "img/solution_building1.d6fd1e29.png";